// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, OnInit, OnDestroy, AfterViewInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatSnackBar, MatDialog } from '@angular/material';
import { fadeInOut } from '../../services/animations';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { Companie } from 'src/app/models/Companie.model';
import * as FileSaver from 'file-saver'; 
import { Permission } from 'src/app/models/permission.model';

@Component({
    selector: 'companiereprezentari',
  templateUrl: './companiereprezentari.component.html',
  styleUrls: ['./companiereprezentari.component.scss'],
    animations: [fadeInOut]
})

export class CompanieReprezentariComponent
{
  private isSaving: boolean;
  private isNew: boolean;
  companieForm: FormGroup;
  companie: Companie;
  definireCompanie: boolean = false;

  denumire: string = '';
  cif: string = '';
  displayedColumns = ['actions', 'denumire', 'reprezentant', 'cif', 'country', 'localitate', 'postalcode', 'adresa', 'stare'];
  isDataLoaded: boolean = false;
  loadingIndicator: boolean = true;
  formResetToggle: boolean = true;
  _currentUserId: string;
  data: Companie[];
  dataSource: MatTableDataSource<Companie>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  //

  afiseazaDate() {
    this.loadingIndicator = true;

    let denumire = this.denumire == null || this.denumire == "" ? "undefined" : this.denumire;
    let cif = this.cif == null || this.cif == "" ? "undefined" : this.cif;
    
    this.accountService
      .getCompaniiReprezentateList(denumire, cif, 'Y')
      .subscribe(results => {
        
        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.data = liniiReconverted;

        this.dataSource.data = this.data;

        this.isDataLoaded = true;

        setTimeout(() => { this.loadingIndicator = false; }, 1500);

      },
        error => {
        });

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  reset() {
    this.denumire = '';
    this.cif = '';
  }

  blocareEditareCIF: boolean;
  modificareCompanie(companie: Companie) {
    this.definireCompanie = true;
    this.companie = companie;
    this.blocareEditareCIF = true;

    this.companie.stareafisare = this.companie.stare == "Neaprobat" ? "In curs de aprobare" : "Aprobat"; 
  }

  adaugare() {
    this.definireCompanie = true;
    this.companie = new Companie();
    this.blocareEditareCIF = false;
  }

  cereAprobareReprezentant(companie: Companie) {
    this.alertService.showDialog('Confirmati', 'Confirmati aprobarea reprezentantului   ' + companie.reprezentant + '   pentru compania   ' + companie.denumire + ' ?', DialogType.confirm, () => this.aprobaCompanie(companie));
  }

  aprobaCompanie(companie: Companie) {
    this.alertService.startLoadingMessage('Confirmare reprezentare...');
    this.accountService.aprobareReprezentareCompanie(companie).subscribe(
      role => this.saveSuccessHelper(companie, 'Reprezentarea a fost aprobata!'),
      error => this.saveFailedHelper(error));
  }
  
  //

  afuConfig = {
    uploadAPI: {
      url: "https://example-file-upload-api"
    }
  };

  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
  )
  {
    this.dataSource = new MatTableDataSource<Companie>();
    this.buildForm();
  }

  ngOnInit() {
    this.companie = new Companie();
    this.afiseazaDate();
  }
  
  save() {
    //console.log("abcd");
    //if (this.companieForm.valid) {
      //console.log("efgh");
      this.accountService.newCompanie(this.companie).subscribe(
        role => this.saveSuccessHelper(this.companie, `Datele companiei au fost salvate cu succes!`),
        error => this.saveFailedHelper(error));
    //}
   // else {
   //   console.log("svfddfv");
   //   console.log(this.companieForm.errors);
   // }
    
  }

  private saveSuccessHelper(companie?: Companie, mesaj?: string) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();

    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);

    this.definireCompanie = false;
    this.afiseazaDate();
  }

  private saveFailedHelper(error: any) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "In procesul de salvare s-au produs urmatoarele erori: ", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

  private buildForm() {
    this.companieForm = this.formBuilder.group({
      tbDenumire: ['', [Validators.required, Validators.minLength(3)],],
      tbType: ['', Validators.required],
      tbCIF: ['', Validators.required],
      tbRegcom: ['', Validators.required],
      tbVAT: ['', Validators.required],
      tbCountry: ['', Validators.required],
      tbLocalitate: ['', Validators.required],
      tbAdresa: ['', Validators.required],
      tbPostalCode: ['', Validators.required],
      tbBanca: ['', Validators.required],
      tbContBancar: ['', Validators.required],
      tbTelefon: ['', Validators.required],
      tbStare: new FormControl({ value: '' })
    });
  }

  get tbVAT() {
    return this.companieForm.get('tbVAT');
  }

  get tbType() {
    return this.companieForm.get('tbType');
  }

  get tbDenumire() {
    return this.companieForm.get('tbDenumire');
  }

  get tbCIF() {
    return this.companieForm.get('tbCIF');
  }

  get tbRegcom() {
    return this.companieForm.get('tbRegcom');
  }

  get tbDocument() {
    return this.companieForm.get('tbDocument');
  }

  get tbLocalitate() {
    return this.companieForm.get('tbLocalitate');
  }

  get tbCountry() {
    return this.companieForm.get('tbCountry');
  }

  get tbAdresa() {
    return this.companieForm.get('tbAdresa');
  }

  get tbPostalCode() {
    return this.companieForm.get('tbPostalCode');
  }

  get tbBanca() {
    return this.companieForm.get('tbBanca');
  }

  get tbContBancar() {
    return this.companieForm.get('tbContBancar');
  }

  get tbTelefon() {
    return this.companieForm.get('tbTelefon');
  }

  get tbStare() {
    return this.companieForm.get('tbStare');
  }
  
  private cancel() {
    this.definireCompanie = false;
    this.afiseazaDate();
  }

  vizualizareDetaliiCompanie(companie: Companie) {
    this.definireCompanie = true;
    this.companie = companie;
    this.blocareEditareCIF = true;
    this.companie.stareafisare = this.companie.stare == "Neaprobat" ? "In curs de aprobare" : "Aprobat";
  }

  descarcaFisier(mod: string) {
    this.accountService.downloadDocumentCompanie(this.companie.reprezentantid, this.companie.id, mod).subscribe(result => {
      let blob = new Blob(result, {
        type: 'application/pdf' // must match the Accept type
      });

      let filename = 'Document_' + mod + '.pdf';
      FileSaver.saveAs(blob, filename);
    });
  }

  verificareStergere(companie: Companie) {
    this.alertService.showDialog('Delete', 'Do you confirm the deletion?', DialogType.confirm, () => this.stergeCompanie(companie));
  }

  stergeCompanie(companie: Companie) {
    companie.status = "D";

    this.accountService.deleteCompany(companie).subscribe(
      role => {
        this.saveSuccessHelper(this.companie, `Company deleted!`);
        this.afiseazaDate();
      },
      error => this.saveFailedHelper(error));

  }

  get manageCompanieReprezentariPermission() {
    return this.accountService.userHasPermission(Permission.manageCompanieReprezentariPermission);
  }

}
